import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TCreativeVideoDetailsSliceInitialState } from './types';
import { fetchVideoDetails } from './creativeVideoDetailsAction';

const initialState: TCreativeVideoDetailsSliceInitialState = {
  videoDetails: undefined,
  videoWebm: undefined
};

const creativeVideoDetailsSlice = createSlice({
  name: 'creativeVideoDetails',
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchVideoDetails.pending, (state) => {
      return {
        ...state,
        videoDetails: undefined
      };
    });
    builder.addCase(
      fetchVideoDetails.fulfilled,
      (state, action: PayloadAction<any>) => {
        return {
          ...state,
          videoDetails: action.payload || {}
        };
      }
    );
    builder.addCase(fetchVideoDetails.rejected, (state) => {
      return {
        ...state,
        videoDetails: undefined
      };
    });
  }
});

export default creativeVideoDetailsSlice.reducer;
